export const CALCULATOR_LOAD = '@calculator/load';
export const CALCULATOR_RESULT = '@calculator/result';
